import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { EmployerService } from 'src/app/employer/employer.service';
import { OPERATION, LOGICAL_OPERATOR } from "../../filter.enum";

@Component({
  selector: 'app-detailed-view',
  templateUrl: './detailed-view.component.html',
  styleUrls: ['./detailed-view.component.css']
})
export class DetailedViewComponent implements OnInit {
  employement_types = [
    { value: "full_time", viewValue: "Full Time" },
    { value: "internship", viewValue: "Internship" },
    { value: "contractor", viewValue: "Contractor" },
  ];
  jobTypes;
  jobRoles;
  searchString;
  autocompleteItems = ["Item1", "item2", "item3"];
  searchData = [];
  searchDataFields = {
    job_role: null,
    location: "",
    employement_type: "",
    job_type: null,
    salary: [200, 1000],
    skills: [],
    date_range: {
      from_date: "",
      to_date: "",
    },
    name: "",
    email: "",
    keyword: "",
    work_email_verified: false,
    single_reference: false,
    multiple_reference: false
  };
  searchResultData = [];
  jobId;
  selectedJobData;

  savedCandidates = [];
  submittedCandidates = [];

  constructor(private employerService: EmployerService, private route: ActivatedRoute) { }

  ngOnInit() {
    this.jobId = this.route.snapshot.paramMap.get('id')
    if (this.jobId) {
      console.log('got job id')
      this.employerService.getJobDetails(this.jobId).subscribe(
        (a) => {
          this.selectedJobData = a;
          console.log(a, this.jobId)
          this.searchDataFields.job_type = a['job_type'].name;
          this.onSearch(1);
        }
      )
    } else {
      console.log('no job id')
      this.onSearch(1);
    }
    this.getJobTypesAndRoles();
  }

  getJobTypesAndRoles() {
    this.employerService.getJobTypes().subscribe(
      (a) => {
        this.jobTypes = a;
      }
    )
    this.employerService.getAllJobRoles().subscribe(
      (a) => {
        this.jobRoles = a;
      }
    )
  }

  createSearchObj() {
    if (this.searchDataFields.job_role) this.createJobRoleObj();

    if (this.searchDataFields.job_type) this.createJobTypeObj();

    if (this.searchDataFields.location) this.createLocationObj();

    if (this.searchDataFields.employement_type) this.createJobEmployementObj();

    if (this.searchDataFields.salary) this.createSalaryObj();

    if (this.searchDataFields.skills) this.createSkillsObj();

    if (this.searchDataFields.date_range.from_date) this.createDateRangeObj();

    if (this.searchDataFields.name) this.createNameObj();

    if (this.searchDataFields.email) this.createEmailObj();

    if (this.searchDataFields.keyword) this.createKeywordObj();
  }

  createJobRoleObj() {
    let obj = {
      criteria: [
        this.createSearchSimpleObj(
          "resume.job_roles",
          this.searchDataFields.job_role,
          OPERATION.CONTAINS
        ),
      ],
    };
    this.searchData.push(obj);
  }

  createJobTypeObj() {
    let obj = {
      criteria: [
        this.createSearchSimpleObj(
          "resume.job_type.name",
          this.searchDataFields.job_type,
          OPERATION.EQUALS
        ),
      ],
    };
    this.searchData.push(obj);
  }

  createKeywordObj() {
    let obj = {
      criteria: [
        this.createSearchSimpleObj(
          "resume.work_experience.description",
          this.searchDataFields.keyword,
          OPERATION.CONTAINS
        ),
      ],
    };
    this.searchData.push(obj);
  }

  createLocationObj() {
    let obj = {
      criteria: [
        this.createSearchSimpleObj(
          "resume.preferences.preferred_location",
          this.searchDataFields.location,
          OPERATION.CONTAINS
        ),
        this.createSearchSimpleObj(
          "resume.preferences.any_state_in_usa",
          true,
          OPERATION.EQUALS
        ),
      ],
      logicalOperator: LOGICAL_OPERATOR.OR,
    };
    this.searchData.push(obj);
  }

  createJobEmployementObj() {
    //Change This TODO......
    let obj = {
      criteria: [
        this.createSearchSimpleObj(
          `resume.preferences.employement_types.${this.searchDataFields.employement_type}.selected`,
          true,
          OPERATION.EQUALS
        ),
      ],
    };
    this.searchData.push(obj);
  }

  createSalaryObj() {
    let obj = {
      criteria: [
        this.createSearchRangeObj(
          `resume.preferences.employement_types.${this.searchDataFields.employement_type}.preferred_salary`,
          this.searchDataFields.salary[0],
          this.searchDataFields.salary[1]
        ),
        this.createSearchSimpleObj(
          `resume.preferences.employement_types.${this.searchDataFields.employement_type}.is_negotialble`,
          true,
          OPERATION.EQUALS
        ),
      ],
      logicalOperator: LOGICAL_OPERATOR.OR,
    };
    this.searchData.push(obj);
  }

  createSkillsObj() {
    this.searchDataFields.skills.forEach((a) => {
      let obj = {
        criteria: [
          this.createSearchSimpleObj(
            "resume.skills.primarySkills",
            a.value,
            OPERATION.CONTAINS
          ),
          this.createSearchSimpleObj(
            "resume.skills.additionalSkills",
            a.value,
            OPERATION.CONTAINS
          ),
        ],
        logicalOperator: LOGICAL_OPERATOR.OR,
      };
      this.searchData.push(obj);
    });
  }

  createDateRangeObj() {
    let obj = {
      criteria: [
        this.createSearchRangeObj(
          "create_date",
          this.searchDataFields.date_range.from_date,
          this.searchDataFields.date_range.to_date
            ? this.searchDataFields.date_range.to_date
            : ""
        ),
      ],
    };
    this.searchData.push(obj);
  }

  createNameObj() {
    let obj = {
      criteria: [
        this.createSearchSimpleObj(
          "profile.first_name",
          this.searchDataFields.name,
          OPERATION.CONTAINS
        ),
        this.createSearchSimpleObj(
          "profile.last_name",
          this.searchDataFields.name,
          OPERATION.CONTAINS
        ),
      ],
      logicalOperator: LOGICAL_OPERATOR.OR,
    };
    this.searchData.push(obj);
  }

  createEmailObj() {
    let obj = {
      criteria: [
        this.createSearchSimpleObj(
          "profile.email_id",
          this.searchDataFields.job_role,
          OPERATION.CONTAINS
        ),
      ],
    };
    this.searchData.push(obj);
  }

  createSearchSimpleObj(fieldName, value, operation) {
    let obj = {
      fieldName: fieldName,
      value: value,
      operation: operation,
    };
    return obj;
  }

  createSearchRangeObj(fieldName, minValue, maxValue) {
    let obj = {
      fieldName: fieldName,
      minValue: minValue,
      maxValue: maxValue,
    };
    return obj;
  }

  createCandidateSearchRangeObj(value){
    let obj = {
      criteria: [
        this.createSearchSimpleObj(
          "_id",
          value,
          OPERATION.EQUALS
        ),
      ],
    };
    this.searchData.push(obj);
  }

  onSearch(pageIndex?) {
    console.log(this.searchDataFields);
    this.createSearchObj();
    console.log(this.searchData);
    this.employerService.searchCandidates({ searchData: this.searchData, pageIndex: pageIndex }).subscribe((a: any) => {
      console.log(a);
      this.searchResultData = a;
      this.clearSearchFields();
    });
  }

  clearSearchFields(clearAll?) {
    this.searchDataFields = {
      job_role: null,
      location: "",
      employement_type: "",
      job_type: null,
      salary: [0, 500],
      skills: [],
      date_range: {
        from_date: "",
        to_date: "",
      },
      name: "",
      email: "",
      keyword: "",
      work_email_verified: false,
      single_reference: false,
      multiple_reference: false
    };
    this.searchData = []
    if (clearAll === true) {
      this.searchResultData = [];
    }
  }
}
